// ============================================================
// 数据动画：Hero 计数、技能条填充、whoami ASCII 注入
// ============================================================

// JKDY 标准 5x7 像素字体（█ 单块点阵）
// 说明：K 的斜腿交叉需要 5 列像素才能正确表达，4 列(██ 双块)会渲染成 U，故采用 5 列像素方案
const ASCII_ART = [
  "█████ █···█ ████· █···█",
  "···█· █··█· █··█· ·█·█·",
  "···█· █·█·· █··█· ··█··",
  "···█· ███·· █··█· ··█··",
  "···█· █·█·· █··█· ··█··",
  "█··█· █··█· █··█· ··█··",
  "·██·· █···█ ████· ··█··",
].join("\n");

// ---------- 遥测模拟：GPU / FPS / LATENCY 动态监控 ----------
// 用「随机游走」模拟真实系统遥测读数：每次采样在上次基础上小幅增减，
// 并钳制在合理区间内，避免数值越界或突变过大，观感自然（类似真实监控曲线）。
const MONITOR = [
  {
    selector: ".hero-stat:nth-child(1) .count", // GPU LOAD
    base: 87,
    min: 62,
    max: 96,
    step: 3, // 单次最大变化量
    ms: 2000, // 采样间隔
  },
  {
    selector: ".hero-stat:nth-child(2) .count", // RENDER FPS
    base: 144,
    min: 118,
    max: 165,
    step: 4,
    ms: 1500,
  },
  {
    selector: ".hero-stat:nth-child(3) .count", // LATENCY
    base: 9,
    min: 5,
    max: 22,
    step: 2,
    ms: 2500,
  },
];

// 启动遥测刷新（在开机动画结束、计数动画完成后运行，避免相互覆盖）
function initMonitor() {
  MONITOR.forEach((m) => {
    const el = document.querySelector(m.selector);
    if (!el) return;
    let v = m.base;
    el.textContent = v;
    setInterval(() => {
      // 随机游走：±step 内随机偏移，并钳制在 [min, max]
      const delta = (Math.random() - 0.5) * 2 * m.step;
      v = Math.round(Math.min(m.max, Math.max(m.min, v + delta)));
      el.textContent = v;
    }, m.ms);
  });
}

export default function initStats() {
  // whoami ASCII 注入
  const ascii = document.querySelector(".ascii-art");
  if (ascii) ascii.textContent = ASCII_ART;

  // 开机完成后延迟启动遥测模拟（跳过 boot 覆盖屏，避免被遮挡）
  window.addEventListener(
    "jk:booted",
    () => setTimeout(initMonitor, 1600),
    { once: true }
  );

  const counts = document.querySelectorAll(".count[data-count]");
  const fills = document.querySelectorAll(".skill__fill[data-fill]");
  if (!counts.length && !fills.length) return;

  if (!("IntersectionObserver" in window)) {
    counts.forEach((el) => {
      el.textContent = el.dataset.count;
    });
    fills.forEach((el) => {
      el.style.width = `${el.dataset.fill}%`;
    });
    return;
  }

  const animateCount = (el) => {
    const target = parseInt(el.dataset.count, 10) || 0;
    const dur = 1300;
    const t0 = performance.now();
    const step = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll(".count[data-count]").forEach(animateCount);
        entry.target.querySelectorAll(".skill__fill[data-fill]").forEach((el) => {
          el.style.width = `${el.dataset.fill}%`;
        });
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.3 }
  );

  counts.forEach((el) => {
    const scope = el.closest("[data-reveal]") || document.body;
    io.observe(scope === document.body ? el : scope);
  });
  fills.forEach((el) => {
    const scope = el.closest("[data-reveal]") || el;
    io.observe(scope);
  });
}
